import React from 'react';
import CourseTemplate from '../../components/CourseTemplate';

const BAEconomicsCoursePage: React.FC = () => {
  const courseData = {
    title: "B.A. Economics",
    shortName: "B.A. Economics",
    duration: "3 years",
    description: "Bachelor's degree program focused on economic theory, policy analysis, and quantitative methods",
    overview: "Bachelor of Arts in Economics (B.A. Economics) is a 3-year undergraduate program that provides comprehensive study of microeconomics, macroeconomics, econometrics, and economic policy. This course covers economic theory, statistical analysis, financial markets, development economics, and policy formulation, preparing students for careers in banking, finance, government, and research.",
    eligibility: [
      "10+2 in any stream",
      "Minimum 50% marks in 12th standard",
      "Mathematics background preferred",
      "Interest in economic and financial matters"
    ],
    
    curriculum: [
      {
        year: 1,
        subjects: [
          "Principles of Microeconomics",
          "Principles of Macroeconomics",
          "Mathematical Methods in Economics",
          "Statistics for Economics",
          "Indian Economy",
          "Computer Applications"
        ]
      },
      {
        year: 2,
        subjects: [
          "Intermediate Microeconomics",
          "Intermediate Macroeconomics",
          "Money and Banking",
          "Public Finance",
          "International Economics",
          "Economic History"
        ]
      },
      {
        year: 3,
        subjects: [
          "Development Economics",
          "Econometrics",
          "Environmental Economics",
          "Labour Economics",
          "Research Project",
          "Internship"
        ]
      }
    ],

    careerProspects: {
      roles: [
        "Economic Analyst",
        "Banking Professional",
        "Financial Analyst",
        "Policy Researcher",
        "Investment Advisor",
        "Data Analyst",
        "Market Research Analyst",
        "Government Economist",
        "Business Consultant",
        "Academic Researcher"
      ],
      industries: [
        "Banking and Finance",
        "Government Organizations",
        "Consulting Firms",
        "Research Institutions",
        "Insurance Companies",
        "Stock Exchanges",
        "International Organizations",
        "Non-Profit Sector",
        "Media and Journalism",
        "Corporate Sector"
      ],
      averageSalary: "₹4-8 LPA (Fresher), ₹15-40 LPA (Experienced)",
      topRecruiters: [
        "RBI, SBI, HDFC Bank",
        "ICICI, Axis Bank",
        "Deloitte, PwC, EY",
        "Government Departments",
        "NITI Aayog, Planning Commission",
        "Investment Banks"
      ]
    },

    admissionProcess: [
      "Merit-based admission through 12th marks",
      "Some universities conduct entrance tests",
      "DU, BHU conduct specific entrance exams",
      "Cut-off based selection",
      "Online application process"
    ],

    topColleges: [
      {
        name: "Shri Ram College of Commerce",
        location: "Delhi",
        fees: "₹40,000",
        ranking: "NIRF Ranking: 1"
      },
      {
        name: "Lady Shri Ram College",
        location: "Delhi",
        fees: "₹35,000",
        ranking: "NIRF Ranking: 3"
      },
      {
        name: "Presidency College",
        location: "Chennai",
        fees: "₹15,000",
        ranking: "Premier Government College"
      },
      {
        name: "Christ University",
        location: "Bangalore",
        fees: "₹1,80,000",
        ranking: "Deemed University"
      }
    ],

    skills: [
      "Economic Analysis",
      "Statistical Analysis",
      "Data Interpretation",
      "Mathematical Modeling",
      "Policy Analysis",
      "Research Methods",
      "Financial Planning",
      "Quantitative Skills",
      "Report Writing",
      "Critical Thinking"
    ],

    futureScope: "Excellent prospects with growing importance of data analytics, financial planning, economic policy making, and increasing demand for economic expertise in business and government.",

    faqs: [
      {
        question: "What career options are available after B.A. Economics?",
        answer: "Career options include banking, financial services, government economist positions, consulting, research, civil services, and further studies like M.A. Economics or MBA."
      },
      {
        question: "Can I work in banking with Economics degree?",
        answer: "Yes, economics graduates are highly sought after in banking for roles in credit analysis, policy research, economic research, and financial planning."
      },
      {
        question: "Is mathematics important for Economics?",
        answer: "Yes, mathematics and statistics are crucial for economic analysis, econometrics, and quantitative research. Strong math skills enhance career prospects."
      },
      {
        question: "Can I pursue MBA after B.A. Economics?",
        answer: "Yes, economics provides excellent foundation for MBA, especially in finance, consulting, and strategy specializations."
      }
    ]
  };

  return (
    <div className="min-h-screen w-full bg-gradient-to-br from-[#0f172a] via-[#1e293b] to-black flex flex-col items-center justify-start py-8 px-2">
      <h1 className="text-4xl md:text-5xl font-extrabold text-transparent bg-clip-text bg-gradient-to-r from-cyan-400 via-pink-400 to-purple-400 drop-shadow-glow mb-6 text-center animate-glow">
        {courseData.title}
      </h1>
      <div className="w-full max-w-4xl">
        <CourseTemplate courseData={courseData} />
      </div>
    </div>
  );
};

export default BAEconomicsCoursePage;
